import { render } from "./Mainpic.vue?vue&type=template&id=167bd5ec"
import script from "./Mainpic.vue?vue&type=script&lang=js"
export * from "./Mainpic.vue?vue&type=script&lang=js"

import "./Mainpic.vue?vue&type=style&index=0&id=167bd5ec&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__